import { useSelector } from "react-redux";
import { LOCAL_STORAGE } from "./Constants/LocalStorage";



const DefaultMenu = (props) => {
    const user = useSelector((state) => state.auth);
    const { MenuCard } = props;

    return (
        JSON.parse(localStorage.getItem(LOCAL_STORAGE.MAIN_NAVIGATION)).map((menu, index) => (
            <MenuCard key={index} menu={menu} />
        )))
};

export default DefaultMenu;
